import React from 'react';
import styled from 'styled-components';
import { ScreenSize, useScreenSize } from '../../contexts/ScreenSizeContext';
import { Tags } from '../../consts/tags';

interface ProjectCardProps {
  description: string;
  image: string;
  link?: string;
  title: string;
  tags?: Tags;
}

const Card = styled.div<{ $screenSize: ScreenSize }>`
  padding: ${({ $screenSize }) => ($screenSize === 'mobile' ? '5px' : '25px')};
  max-width: ${({ $screenSize }) => ($screenSize === 'mobile' ? '90vw' : '40vw')};
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

const ProjectImage = styled.img<{ $screenSize: ScreenSize }>`
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 15px;
  height: auto;
  cursor: pointer;
  transition: transform 0.3s ease;
  width: ${({ $screenSize }) => ($screenSize === 'mobile' ? '80vw' : '100%')};
  height: ${({ $screenSize }) => ($screenSize === 'mobile' ? '80vw' : '300px')};
  object-fit: cover;
  &:hover {
    transform: scale(1.05);
  }
`;

const TitleContainer = styled.div`
  display: flex;
  justify-content: center;
  cursor: pointer;
`;

const Title = styled.div`
  margin-top: 10px;
  position: relative;
  font-size: 1.25rem;
  position: relative;
  width: auto;
  /* Pseudo-element for the underline effect */
  &::after {
    content: '';
    position: absolute;
    height: 5px;
    left: 0;
    bottom: 0;
    width: 0;
    background: ${({ theme }) => theme.onHover || 'white'};
    transition: width 0.2s;
  }
  &:hover::after {
    width: 100%;
  }
`;

const Description = styled.p`
  font-size: 1rem;
  color: ${({ theme }) => theme.fontColorSecondary || 'white'};
  text-align: left;
  line-height: 1.5rem;
`;

const TagContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 10px;
`;

const Tag = styled.span`
  color: ${({ theme }) => theme.onHover || 'white'};
  font-weight: 600;
  margin-right: 10px;
`;

const ProjectCard: React.FC<ProjectCardProps> = ({
  image,
  title,
  description,
  link = '',
  tags = [],
}) => {
  const { screenSize } = useScreenSize();
  return (
    <Card
      $screenSize={screenSize}
      onClick={() => (window.location.href = link)}
    >
      <ProjectImage src={image} alt={title} $screenSize={screenSize} />
      <TagContainer>
        {tags.map((tag: string) => {
          return <Tag key={tag}>{tag}</Tag>;
        })}
      </TagContainer>
      <TitleContainer>
        <Title>{title}</Title>
      </TitleContainer>
      <Description>{description}</Description>
    </Card>
  );
};

export default ProjectCard;
